/**
 * Copy and ExActionsPopUp flags for Job Family lifecycle confirms.
 */
export const JOB_FAMILY_CONFIRM_ACTIONS = [
  "activate",
  "retire",
  "reactivate",
  "archive",
  "unarchive",
];

const COPY = {
  activate: {
    headline: "Activate Job Family",
    actionLabel: "Activate",
    destructive: false,
    primary: true,
    termination: false,
    info: (name) =>
      `You are about to activate Job Family ${name}. Once activated, it cannot return to Draft.`,
  },
  retire: {
    headline: "Retire Job Family",
    actionLabel: "Retire",
    destructive: false,
    primary: false,
    termination: true,
    info: (name) => `You are about to retire Job Family ${name}.`,
  },
  reactivate: {
    headline: "Reactivate Job Family",
    actionLabel: "Reactivate",
    destructive: false,
    primary: true,
    termination: false,
    info: (name) => `You are about to reactivate Job Family ${name}.`,
  },
  archive: {
    headline: "Archive Job Family",
    actionLabel: "Archive",
    destructive: true,
    primary: false,
    termination: false,
    info: (name) => `Job Family ${name} is about to be archived.`,
  },
  unarchive: {
    headline: "Unarchive Job Family",
    actionLabel: "Unarchive",
    destructive: false,
    primary: false,
    termination: false,
    info: (name) => `Job Family ${name} is about to be unarchived.`,
  },
};

export function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function confirmViewFor(action, name) {
  const key = JOB_FAMILY_CONFIRM_ACTIONS.includes(action) ? action : "activate";
  const copy = COPY[key];
  const safeName = escapeHtml(String(name || "").trim() || "this job family");
  return {
    action: key,
    headline: copy.headline,
    actionLabel: copy.actionLabel,
    destructive: copy.destructive,
    primary: copy.primary,
    termination: copy.termination,
    htmlInfo: `<div style="max-width: 414px; margin: 0 auto; margin-top: 26px;">${copy.info(
      safeName
    )}</div>`,
  };
}
